import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { getAlternateUrl } from '../config/routes';

/**
 * Hreflang component for SEO
 * Adds alternate language links for better international SEO
 */
const Hreflang = () => {
  const location = useLocation();
  const baseUrl = 'https://pikagency.de';
  
  // Get current path
  const currentPath = location.pathname;
  
  // Get alternate URLs
  const enUrl = currentPath.startsWith('/de') ? getAlternateUrl(currentPath, 'en') : currentPath;
  const deUrl = !currentPath.startsWith('/de') ? getAlternateUrl(currentPath, 'de') : currentPath;
  
  return (
    <Helmet>
      <link rel="alternate" hrefLang="en" href={`${baseUrl}${enUrl}`} />
      <link rel="alternate" hrefLang="de" href={`${baseUrl}${deUrl}`} />
      <link rel="alternate" hrefLang="x-default" href={`${baseUrl}${enUrl}`} />
    </Helmet>
  );
};

export default Hreflang;
